import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	boardTitle: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'servicedesk-itsm-features.app.sections.labs-section.jsm-board-title',
		defaultMessage: 'Board',
		description: 'Title text of the JSM boards features panel',
	},
	boardDescription: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'servicedesk-itsm-features.app.sections.labs-section.jsm-board-description',
		defaultMessage:
			"Visualize your work with a board to track the progress of all issues in your project. Add, rename, or remove columns in your board to match your team's preferred way of working. {learnMoreLink}.",
		description: 'Description text of the JSM board features panel',
	},
	boardLink: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'servicedesk-itsm-features.app.sections.labs-section.jsm-board-link',
		defaultMessage: 'Learn more about setting up a board',
		description: 'Text used for the the JSM board learn more link',
	},
	calendarTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-title',
		defaultMessage: 'Calendar',
		description: 'Title text of the calendar features panel',
	},
	calendarDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-description',
		defaultMessage:
			'Visualize your work with a calendar to track, plan and prioritize your issues. {learnMoreLink}.',
		description: 'Description text of the calendar features panel',
	},
	calendarLink: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-link',
		defaultMessage: 'Learn more about calendar view',
		description: 'Text used for the the calendar features panel learn more link',
	},
	viewsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.views-title.non-final',
		defaultMessage: 'Views',
		description: 'Title text of the views features panel',
	},
	viewsDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.views-description.non-final',
		defaultMessage:
			'Visualize your issues in the way that works best for you. Use the Default view settings to select which views are available to your team, such as <b>board</b> and <b>calendar</b>. <link>Read more about views</link>',
		description: 'Description text of the calendar features panel',
	},
	selectViewsButton: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.select-views-button.non-final',
		defaultMessage: 'Select views',
		description: 'Text used for the select views button',
	},
	noPermissionTooltipMessage: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.no-permission-tooltip-message',
		defaultMessage:
			'Ask your jira admin for the <strong>Browse projects</strong> permission to enable this feature.',
		description: 'Tooltip on the reasoning why user can not enable the board or calendar features',
	},
	newLozenge: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.new-lozenge',
		defaultMessage: 'New',
		description:
			'Small lozenge that appears to the right of the feature title, indicating a new feature.',
	},

	// calendar success flag messages
	calendarFlagSuccessTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-flag-success-title',
		defaultMessage: 'Calendar {value, select, true {enabled} false {disabled} other {}}',
		description: 'Title of the success flag when enabling the feature',
	},
	calendarEnabledSuccessFlagDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-enabled-success-flag-description',
		defaultMessage:
			'Start scheduling your work by adding a start date and due date to your issues.',
		description: 'Description of the success flag when enabling the calendar feature',
	},
	calendarDisabledSuccessFlagDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-disabled-success-flag-description',
		defaultMessage: 'You can enable it again at any time.',
		description: 'Title of the success flag when disabling the calendar feature',
	},
	calendarFeatureSuccessEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-feature-success-enable-action',
		defaultMessage: 'View calendar',
		description: 'Action button text of the success flag when enabling the calendar feature',
	},
	calendarFeatureSuccessDisableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.calendar-feature-success-disable-dismiss',
		defaultMessage: 'Ok',
		description: 'Dismiss button text of the success flag when disabling the calendar feature',
	},

	// board success flag messages
	boardFlagSuccessTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.board-flag-success-title',
		defaultMessage: 'Board {value, select, true {enabled} false {turned off} other {}}',
		description: 'Title of the success flag when enabling the feature',
	},
	boardDisabledSuccessFlagDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.board-disabled-success-flag-description',
		defaultMessage: 'You can enable your board again at any time.',
		description: 'Title of the success flag when disabling the board feature',
	},
	boardFeatureSuccessEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.board-feature-success-enable-action',
		defaultMessage: 'Go to board',
		description: 'Action button text of the success flag when enabling the board feature',
	},
	boardFeatureSuccessDisableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.board-feature-success-disable-dismiss',
		defaultMessage: 'Ok',
		description: 'Dismiss button text of the success flag when disabling the board feature',
	},

	// views success flag messages
	viewsFlagSuccessTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.views-flag-success-title.non-final',
		defaultMessage: 'Views {value, select, true {enabled} false {turned off} other {}}',
		description: 'Title of the success flag when enabling the views feature',
	},
	viewsEnabledSuccessFlagDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.views-enabled-success-flag-description.non-final',
		defaultMessage: 'You can disable views through "Select views" button.',
		description: 'Title of the success flag when enabling the views feature',
	},
	viewsDisabledSuccessFlagDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.views-disabled-success-flag-description.non-final',
		defaultMessage: 'You can enable views again at any time.',
		description: 'Title of the success flag when disabling the views feature',
	},
	viewsFeatureSuccessEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.views-feature-success-enable-action',
		defaultMessage: 'Ok',
		description: 'Action button text of the success flag when enabling the views feature',
	},
	viewsFeatureSuccessDisableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.views-feature-success-disable-action.non-final',
		defaultMessage: 'Ok',
		description: 'Action button text of the success flag when disabling the views feature',
	},

	// Error flag messages
	enabledErrorTitleForCalendar: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.enabled-error-title-for-calendar',
		defaultMessage:
			'We couldn’t {value, select, false {disable} true {enable} other {action}} the calendar',
		description: 'Title text of error flag when there is an error enabling a calendar feature',
	},
	enabledErrorTitleForBoard: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.enabled-error-title-for-board',
		defaultMessage:
			'We couldn’t {value, select, false {turn off} true {enable} other {action}} your board',
		description: 'Title text of error flag when there is an error enabling a board feature',
	},
	enabledErrorTitleForViews: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.enabled-error-title-for-views.non-final',
		defaultMessage:
			'We couldn’t {value, select, false {disable} true {enable} other {action}} the views',
		description: 'Title text of error flag when there is an error enabling a views feature',
	},
	saveErrorDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-features.save-error-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Body text of error flag',
	},
});
